export default __webpack_public_path__ + "99a61dc21af3008ecd6da37409f4c02f.svg";